import { Component, OnInit } from '@angular/core';
import { Observable } from 'rxjs';
import { AppComponent } from '../../app.component';
import { utils, WorkBook, WorkSheet, writeFile } from 'xlsx';
import { FirebaseFunctionsService } from '../../services/firebase-functions.service';

@Component({
  selector: 'app-participants',
  templateUrl: './participants.component.html',
  styleUrls: ['./participants.component.scss']
})
export class ParticipantsComponent implements OnInit {

  selectionnedOption: string;
  header: string[];
  allUsers: Observable<any>;
  Users: Observable<any>;
  allUsersNum: number;
  admin_debut: Date;
  admin_fin: Date;
  utilisateursTemps: any[] = [];
  ecolesActivities: any[] = [];
  userActivities: any[] = [];
  userActivitiesTemps: any[] = [];
  activities:Observable<any>;
  
  constructor(private app: AppComponent, private afs: FirebaseFunctionsService) { }

  ngOnInit(): void {
    setTimeout(this.app.afficherPage, 2000);
    (document.querySelector('.admin_select') as HTMLSelectElement).addEventListener( 'change', () => {
      if(this.selectionnedOption == '1'){
        this.getUtilisateurs();
        this.getUsers();
      }else if(this.selectionnedOption == '2'){
        const debut = (document.querySelector('.admin_debut') as HTMLInputElement);
        debut.value = new Date().toLocaleDateString();
        const fin = (document.querySelector('.admin_fin') as HTMLInputElement);
        fin.value = new Date().toLocaleDateString();
      }else if(this.selectionnedOption == '3'){
        this.getClasses();
      }else if(this.selectionnedOption == '5'){
        this.getActivities();
        this.getActivitiesBySchool();
      }else if(this.selectionnedOption == '6'){
        this.getActivities();
        this.ecolesActivities = [];
      }else if(this.selectionnedOption == '7'){
        this.getActivities();
        this.getUserActivites();
      }else if(this.selectionnedOption == '8'){
        this.getActivities();
        this.userActivitiesTemps = [];
      }
    });
  }
  getUtilisateurs(){
    this.allUsers = this.afs.getAllUsers();
    this.allUsers.subscribe(users => {
      this.allUsersNum = users.length;
    });
  }
  getActivities(){
    this.activities = this.afs.getActivities();
  }
  getUtilisateursTempsFort(){
    this.admin_debut = (this.admin_debut == undefined)? new Date(): this.admin_debut;
    this.admin_fin = (this.admin_fin == undefined)? new Date(): this.admin_fin;
    if(this.dateValidation()){
      this.utilisateursTemps = [];
      this.afs.getUtilisateursTemps().subscribe( utilisateurs => {
        utilisateurs.forEach(utilisateur => {
          this.afs.getUtilisateur(utilisateur['userId']).subscribe( userData => {
            this.afs.getEcole(userData['ecole_id']).subscribe( ecoleData => {
              this.afs.getRegion(ecoleData['region_id']).subscribe(regionData => {
                let seul = 0; let famille = 0;let classes = 0;
                this.afs.getUserTemps(userData['userId'],this.admin_debut,this.admin_fin).subscribe( temps => {
                  temps.forEach( temp => {
                    const date = new Date(temp.data()['created'].toDate()).toLocaleDateString();
                    const dateDebut = new Date(this.admin_debut+'T00:00:00').toLocaleDateString();
                    const dateFin = new Date(this.admin_fin+'T00:00:00').toLocaleDateString();
                    if(date >= dateDebut && date <= dateFin ){
                      if(temp.data()['type'] == 1){
                        seul = seul + temp.data()['nbrEtoiles'];
                      }else if(temp.data()['type'] == 2){
                        famille = famille + temp.data()['nbrEtoiles'];
                      }else{
                        classes = classes + temp.data()['nbrEtoiles'];
                      }
                    }
                  });
                  const data = {
                    prenom: userData['prenom'],
                    nom: userData['nom'],
                    seul: seul.toFixed(1),
                    enFamille: famille.toFixed(1),
                    enClasse: classes.toFixed(1),
                    total: (seul + famille + classes).toFixed(1),
                    ecole: ecoleData['nom'],
                    region: regionData['nom']
                  };
                  if(this.utilisateursTemps.some(user => user.nom === data.nom && user.prenom === data.prenom && user.ecole === data.ecole)){}else{
                    this.utilisateursTemps.push(data);
                  }
                });
              });
            });
          });
        });
      });
    }
  }
  getActivitiesBySchool(){
    this.ecolesActivities = [];
    this.afs.getAllEcoles().subscribe(ecoles => {
      ecoles.forEach(ecole => {
        this.afs.getRegion(ecole.data()['region_id']).subscribe( region => {
          const data = {ecoleName: ecole.data()['nom'],total: ecole.data()['medailles'],region: region['nom'],
                          athletisme: 0,badminton	: 0,improvisation	: 0,miniHandball: 0,	soccer : 0,ultimateFrisbee	: 0,
                          veloDEmontagne: 0,voix: 0,volleyBall: 0,autresSportives	: 0,autresCulturelles	: 0,leadership: 0}
          if(ecole.data()['cumul_par_activites'] !== undefined){
            for (const [key, value] of Object.entries(ecole.data()['cumul_par_activites'])) {
              switch(key){
                case '702PfsgsiKdx6fMFLvOE': data.miniHandball = (typeof value === 'number')? value : 0;break;
                case 'Af5oEgwvmFl1vvSzOW3A': data.veloDEmontagne = (typeof value === 'number')? value : 0;break;
                case '6F38LjFB50EtNpy2c1oG': data.badminton = (typeof value === 'number')? value : 0;break;
                case 'IFEElFo476sRHvSuYWmt': data.soccer = (typeof value === 'number')? value : 0;break;
                case 'KfmmGnDkZYNT5SzKlNVp': data.volleyBall = (typeof value === 'number')? value : 0;break;
                case 'ObZ74Nm1YXmHTCFJrAmF': data.improvisation = (typeof value === 'number')? value : 0;break;
                case 'Yjmp6pAVQJgO5r7WqXof': data.autresSportives = (typeof value === 'number')? value : 0;break;
                case 'aJnugJ9k7h5ZQbiW25S1': data.ultimateFrisbee = (typeof value === 'number')? value : 0;break;
                case 'fi4QAwJtvBWxNJxNU7QO': data.voix = (typeof value === 'number')? value : 0;break;
                case 'lVhlefwh8AcQ2JgFzYAU': data.athletisme = (typeof value === 'number')? value : 0;break;
                case 'zb7uGR1YAjDhVNd0v2k6': data.autresCulturelles = (typeof value === 'number')? value : 0;break;
                case 'x4SblqonEMKsmtb6SCOU': data.leadership = (typeof value === 'number')? value : 0;break;
              }
            }
          }
          if(this.ecolesActivities.some(ecl => ecl.ecoleName === data.ecoleName && ecl.region === data.region)){}else{
            this.ecolesActivities.push(data);
          }
        });
      });
    });
  }
  getActivitiesBySchoolTemps(){
    this.admin_debut = (this.admin_debut == undefined)? new Date(): this.admin_debut;
    this.admin_fin = (this.admin_fin == undefined)? new Date(): this.admin_fin;
    if(this.dateValidation()){
      this.ecolesActivities = [];
      this.afs.getAllEcoles().subscribe(ecoles => {
        ecoles.forEach(ecole => {
          this.afs.getRegion(ecole.data()['region_id']).subscribe( region => {
            this.afs.getSchoolTemps(ecole.data()['ecole_id']).subscribe(etls => {
              const data = {  ecoleName: ecole.data()['nom'],total: 0,region: region['nom'],
                            athletisme: 0,badminton	: 0,improvisation	: 0,miniHandball: 0,	soccer : 0,ultimateFrisbee	: 0,
                            veloDEmontagne: 0,voix: 0,volleyBall: 0,autresSportives	: 0,autresCulturelles	: 0,leadership: 0
                          };
              if(etls.size > 0){
                const dateDebut = new Date(this.admin_debut+'T00:00:00').toLocaleDateString();
                const dateFin = new Date(this.admin_fin+'T00:00:00').toLocaleDateString();
                etls.forEach(etoile => {
                  const date = new Date(etoile.data()['created'].toDate()).toLocaleDateString();
                  if(date >= dateDebut && date <= dateFin ){
                    switch (etoile.data()['activityId']) {
                      case '702PfsgsiKdx6fMFLvOE': data.miniHandball = data.miniHandball + etoile.data()['nbrEtoiles'];break;
                      case 'Af5oEgwvmFl1vvSzOW3A': data.veloDEmontagne = data.veloDEmontagne + etoile.data()['nbrEtoiles'];break;
                      case '6F38LjFB50EtNpy2c1oG': data.badminton = data.badminton + etoile.data()['nbrEtoiles'] ;break;
                      case 'IFEElFo476sRHvSuYWmt': data.soccer = data.soccer + etoile.data()['nbrEtoiles'];break;
                      case 'KfmmGnDkZYNT5SzKlNVp': data.volleyBall = data.volleyBall + etoile.data()['nbrEtoiles'];break;
                      case 'ObZ74Nm1YXmHTCFJrAmF': data.improvisation = data.improvisation + etoile.data()['nbrEtoiles'] ;break;
                      case 'Yjmp6pAVQJgO5r7WqXof': data.autresSportives = data.autresSportives + etoile.data()['nbrEtoiles'];break;
                      case 'aJnugJ9k7h5ZQbiW25S1': data.ultimateFrisbee = data.ultimateFrisbee + etoile.data()['nbrEtoiles'];break;
                      case 'fi4QAwJtvBWxNJxNU7QO': data.voix = data.voix + etoile.data()['nbrEtoiles'];break;
                      case 'lVhlefwh8AcQ2JgFzYAU': data.athletisme = data.athletisme + etoile.data()['nbrEtoiles'];break;
                      case 'zb7uGR1YAjDhVNd0v2k6': data.autresCulturelles = data.autresCulturelles + etoile.data()['nbrEtoiles'];break;
                      case 'x4SblqonEMKsmtb6SCOU': data.leadership = data.leadership + etoile.data()['nbrEtoiles'];break;
                    }
                  }
                });
              }
              data.total = data.athletisme+data.autresCulturelles+data.autresSportives+data.badminton+data.improvisation+data.leadership+data.miniHandball+data.soccer+data.ultimateFrisbee+data.veloDEmontagne+data.voix+data.volleyBall;
              if(this.ecolesActivities.some(ecl => ecl.ecoleName === data.ecoleName && ecl.region === data.region)){}else{
                this.ecolesActivities.push(data);
              }
            });
          });
        });
      });
    }
  }
  getUserActivites(){
    this.afs.getAllUsers().subscribe( users => {
      this.userActivities = [];
      users.forEach(user => {
        this.afs.getEcole(user['ecole_id']).subscribe(ecole => {
          this.afs.getRegion(ecole['region_id']).subscribe(region => {
            const data = {prenom: user['prenom'],nom: user['nom'],ecole: ecole['nom'],region: region['nom'],
                          athletisme: 0,badminton	: 0,improvisation	: 0,miniHandball: 0,	soccer : 0,ultimateFrisbee	: 0,
                          veloDEmontagne: 0,voix: 0,volleyBall: 0,autresSportives	: 0,autresCulturelles	: 0,leadership: 0
                        };
            if(user['cumul_par_activites'] !== undefined){
              for (const [key, value] of Object.entries(user['cumul_par_activites'])) {
                switch(key){
                  case '702PfsgsiKdx6fMFLvOE': data.miniHandball = (typeof value === 'number')? value : 0;break;
                  case 'Af5oEgwvmFl1vvSzOW3A': data.veloDEmontagne = (typeof value === 'number')? value : 0;break;
                  case '6F38LjFB50EtNpy2c1oG': data.badminton = (typeof value === 'number')? value : 0;break;
                  case 'IFEElFo476sRHvSuYWmt': data.soccer = (typeof value === 'number')? value : 0;break;
                  case 'KfmmGnDkZYNT5SzKlNVp': data.volleyBall = (typeof value === 'number')? value : 0;break;
                  case 'ObZ74Nm1YXmHTCFJrAmF': data.improvisation = (typeof value === 'number')? value : 0;break;
                  case 'Yjmp6pAVQJgO5r7WqXof': data.autresSportives = (typeof value === 'number')? value : 0;break;
                  case 'aJnugJ9k7h5ZQbiW25S1': data.ultimateFrisbee = (typeof value === 'number')? value : 0;break;
                  case 'fi4QAwJtvBWxNJxNU7QO': data.voix = (typeof value === 'number')? value : 0;break;
                  case 'lVhlefwh8AcQ2JgFzYAU': data.athletisme = (typeof value === 'number')? value : 0;break;
                  case 'zb7uGR1YAjDhVNd0v2k6': data.autresCulturelles = (typeof value === 'number')? value : 0;break;
                  case 'x4SblqonEMKsmtb6SCOU': data.leadership = (typeof value === 'number')? value : 0;break;
                }
              }
            }
            if(this.userActivities.some(ecl => ecl.prenom === data.prenom && ecl.region === data.region)){}else{
              this.userActivities.push(data);
            }
          });
        });
      });
    });
  }
  getUserActivitiesTemps(){
    this.admin_debut = (this.admin_debut == undefined)? new Date(): this.admin_debut;
    this.admin_fin = (this.admin_fin == undefined)? new Date(): this.admin_fin;
    if(this.dateValidation()){
      this.afs.getAllUsers().subscribe(users => {
        users.forEach(user => {
          if(user['ecole_id'] !== undefined){
            this.afs.getEcole(user['ecole_id']).subscribe(ecole => {
              this.afs.getRegion(ecole['region_id']).subscribe(region => {
                const data = {prenom: user['prenom'],nom: user['nom'],ecole: ecole['nom'],region: region['nom'],
                              athletisme: 0,badminton	: 0,improvisation	: 0,miniHandball: 0,	soccer : 0,ultimateFrisbee	: 0,
                              veloDEmontagne: 0,voix: 0,volleyBall: 0,autresSportives	: 0,autresCulturelles	: 0,leadership: 0
                            };
                this.afs.getUserTemps(user['userId'], new Date(),new Date()).subscribe(etoiles => {
                  if(etoiles.size > 0){
                    const dateDebut = new Date(this.admin_debut+'T00:00:00').toLocaleDateString();
                    const dateFin = new Date(this.admin_fin+'T00:00:00').toLocaleDateString();
                    etoiles.forEach(etoile => {
                      const date = new Date(etoile.data()['created'].toDate()).toLocaleDateString();
                      if(date >= dateDebut && date <= dateFin ){
                        switch(etoile.data()['activityId']){
                          case '702PfsgsiKdx6fMFLvOE': data.miniHandball = data.miniHandball + etoile.data()['nbrEtoiles'];break;
                          case 'Af5oEgwvmFl1vvSzOW3A': data.veloDEmontagne = data.veloDEmontagne + etoile.data()['nbrEtoiles'];break;
                          case '6F38LjFB50EtNpy2c1oG': data.badminton =data.badminton + etoile.data()['nbrEtoiles'];break;
                          case 'IFEElFo476sRHvSuYWmt': data.soccer = data.soccer + etoile.data()['nbrEtoiles'];break;
                          case 'KfmmGnDkZYNT5SzKlNVp': data.volleyBall = data.volleyBall + etoile.data()['nbrEtoiles'];break;
                          case 'ObZ74Nm1YXmHTCFJrAmF': data.improvisation =data.improvisation + etoile.data()['nbrEtoiles'];break;
                          case 'Yjmp6pAVQJgO5r7WqXof': data.autresSportives =data.autresSportives + etoile.data()['nbrEtoiles'];break;
                          case 'aJnugJ9k7h5ZQbiW25S1': data.ultimateFrisbee =data.ultimateFrisbee + etoile.data()['nbrEtoiles'];break;
                          case 'fi4QAwJtvBWxNJxNU7QO': data.voix = data.voix + etoile.data()['nbrEtoiles'];break;
                          case 'lVhlefwh8AcQ2JgFzYAU': data.athletisme =data.athletisme + etoile.data()['nbrEtoiles'];break;
                          case 'zb7uGR1YAjDhVNd0v2k6': data.autresCulturelles = data.autresCulturelles + etoile.data()['nbrEtoiles'];break;
                          case 'x4SblqonEMKsmtb6SCOU': data.leadership = data.leadership + etoile.data()['nbrEtoiles'];break;
                        }
                      }
                    });
                    if(this.userActivitiesTemps.some(ecl => ecl.prenom === data.prenom && ecl.nom === data.nom && ecl.region === data.region)){}else{
                      this.userActivitiesTemps.push(data);
                    }
                  }
                });
              });
            });
          }
        });
      });
    }
  }
  dateValidation(){
    if(this.admin_debut > this.admin_fin){
      this.afs.showMessage(3, 'La date de debut doit etre inferieur a celle de la fin.', 5000);
      return false;
    }else{
      return true;
    }
  }
  getEcoleName(ecoleId: string){
    return this.afs.getEcoleName(ecoleId);
  }
  getUsers(){
    (document.querySelector('.table_body') as HTMLTableElement).innerHTML = '';
    this.afs.getUsers('.table_body');
  }
  getClasses(){
    (document.querySelector('.table_classe_body') as HTMLElement).innerHTML = '';
    this.afs.getClasses('.table_classe_body');
  }
  getClassesTempsForts(){
    (document.querySelector('.table_classes_body_fort') as HTMLTableElement).innerHTML = '';
    this.admin_debut = (this.admin_debut == undefined)? new Date(): this.admin_debut;
    this.admin_fin = (this.admin_fin == undefined)? new Date(): this.admin_fin;
    if(this.dateValidation()){
      this.afs.getClassesTemps(this.admin_debut,this.admin_fin, '.table_classes_body_fort');
    }
  }
  exportexcel(){
    let fileName = '';
    if(this.selectionnedOption == '1'){
      fileName = 'utilisateurs';
      /* pass here the table id */
      let element = document.querySelector('.excel-table') as HTMLTableElement;
      const ws: WorkSheet = utils.table_to_sheet(element);
  
      /* generate workbook and add the worksheet */
      const wb: WorkBook = utils.book_new();
      utils.book_append_sheet(wb, ws, fileName);
  
      /* save to file */  
      writeFile(wb, `${fileName}.xlsx` );
    }else if(this.selectionnedOption == '2'){
      fileName = 'utilisateur-temps-fort';
      /* pass here the table id */
      let element = document.querySelector('.excel-table_fort') as HTMLTableElement;
      const ws: WorkSheet = utils.table_to_sheet(element);
  
      /* generate workbook and add the worksheet */
      const wb: WorkBook = utils.book_new();
      utils.book_append_sheet(wb, ws, fileName);
  
      /* save to file */  
      writeFile(wb, `${fileName}.xlsx` );
    }else if(this.selectionnedOption == '3'){
      fileName = 'classes';
      /* pass here the table id */
      let element = document.querySelector('.excel-classes_table') as HTMLTableElement;
      const ws: WorkSheet =utils.table_to_sheet(element);
  
      /* generate workbook and add the worksheet */
      const wb: WorkBook = utils.book_new();
      utils.book_append_sheet(wb, ws, fileName);
  
      /* save to file */  
      writeFile(wb, `${fileName}.xlsx` );
    }else if(this.selectionnedOption == '4'){
      fileName = 'temps forts_classes';
      /* pass here the table id */
      let element = document.querySelector('.excel-table_classes_fort') as HTMLTableElement;
      const ws: WorkSheet =utils.table_to_sheet(element);
  
      /* generate workbook and add the worksheet */
      const wb: WorkBook = utils.book_new();
      utils.book_append_sheet(wb, ws, fileName);
  
      /* save to file */  
      writeFile(wb, `${fileName}.xlsx` );
    }else if(this.selectionnedOption == '5'){
      fileName = 'ecoles';
      /* pass here the table id */
      let element = document.querySelector('.excel-classes_table_activities') as HTMLTableElement;
      const ws: WorkSheet =utils.table_to_sheet(element);
  
      /* generate workbook and add the worksheet */
      const wb: WorkBook = utils.book_new();
      utils.book_append_sheet(wb, ws, fileName);
  
      /* save to file */  
      writeFile(wb, `${fileName}.xlsx` );
    }else if(this.selectionnedOption == '6'){
      fileName = 'ecoles-temps_fort';
      /* pass here the table id */
      let element = document.querySelector('.excel-table_activities_fort') as HTMLTableElement;
      const ws: WorkSheet =utils.table_to_sheet(element);
  
      /* generate workbook and add the worksheet */
      const wb: WorkBook = utils.book_new();
      utils.book_append_sheet(wb, ws, fileName);
  
      /* save to file */  
      writeFile(wb, `${fileName}.xlsx` );
    }else if(this.selectionnedOption == '7'){
      fileName = 'Activités par utilisateur';
      /* pass here the table id */
      let element = document.querySelector('.excel-classes_table_activities_user') as HTMLTableElement;
      const ws: WorkSheet =utils.table_to_sheet(element);
  
      /* generate workbook and add the worksheet */
      const wb: WorkBook = utils.book_new();
      utils.book_append_sheet(wb, ws, fileName);
  
      /* save to file */  
      writeFile(wb, `${fileName}.xlsx` );
    }else if(this.selectionnedOption == '8'){
      fileName = 'Actis_utilisateur_temps-fort';
      /* pass here the table id */
      let element = document.querySelector('.excel-table_activities_user_fort') as HTMLTableElement;
      const ws: WorkSheet =utils.table_to_sheet(element);
  
      /* generate workbook and add the worksheet */
      const wb: WorkBook = utils.book_new();
      utils.book_append_sheet(wb, ws, fileName);
  
      /* save to file */  
      writeFile(wb, `${fileName}.xlsx` );
    }
  }
}
